

import { ApiKeyFetch } from 'api/fetchers/apiKey';
import useCustomToast from 'hooks/useCustomToasts';
import useQueryParams from 'hooks/useQueryParams';
import useUsuario from 'hooks/useUsuario';
import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router';
import { guardarTrackingV2 } from 'utils/tracking';
import Loading from 'wrappers/Loading';
import useSuscriptorFunctions from '../components/useSusciptorFunctions';
import { CASUALITY_GENERAL } from '../constantes';

const API = ApiKeyFetch.instance();

const RecuperarCotizacionCasualityGenerales = () => {
    const { addWarningToast } = useCustomToast();
    const { id: idCotizacion, idPoliza } = useQueryParams();
    const history = useHistory();
    const dataUsuario = useUsuario();
    const suscriptorFunctions = useSuscriptorFunctions();

    const getData = useCallback(

        async () => {
            guardarTrackingV2(idCotizacion || '', 'Recuperar cotizacion', 'Recuperacion')

            const DataResumen = {
                idCotizacion,
                idPoliza
            };
            const resRecuperar = await API.post(
                CASUALITY_GENERAL.endpointsV2.resumen,
                DataResumen,
            );
              
            if (resRecuperar.transaccion) {
                    const pasoActual = resRecuperar?.pasoActual ?? '';
                    const { redirect, link } = await suscriptorFunctions.validate(resRecuperar, dataUsuario);debugger
                    if (redirect) { return history.push(link) };
                    if (pasoActual !== '') {
                        switch (pasoActual) {
                            case 'leadPasoEquivalencia':
                                return history.push(`${CASUALITY_GENERAL.urls.datosCliente}?id=${idCotizacion}`)
                            case 'seleccionPlanEquivalencia':
                                return history.push(`${CASUALITY_GENERAL.urls.coberturas}?id=${idCotizacion}`)
                            case 'resumenEquivalencia':
                                return history.push(`${CASUALITY_GENERAL.urls.resumen}?id=${idCotizacion}`)
                            case 'contratanteEquivalencia':
                                //return history.push(`${CASUALITY_GENERAL.urls.contratante}?id=${idPoliza}&idPoliza=${idPoliza}`)
                                return history.push(`${CASUALITY_GENERAL.urls.facturacion}?idCot=${idCotizacion}&idPoliza=${idPoliza}&ramo=${CASUALITY_GENERAL.codProducto}`)
                            case 'vigenciaEquivalencia':
                                return history.push(`${CASUALITY_GENERAL.urls.vigencia}?id=${idPoliza}&idPoliza=${idPoliza}`)
                            case 'pagoEquivalencia':
                                return history.push(`${CASUALITY_GENERAL.urls.pago}?id=${idPoliza}`)
                            default:
                                return history.push(`${CASUALITY_GENERAL.urls.datosCliente}?id=${idCotizacion}`);
                        }
                    }
                addWarningToast(resRecuperar?.cotConsulta?.mensajeRedireccion);
                return history.push(`/`);
            } else {
                addWarningToast('Ha ocurrido un problema al recuperar la cotización');
                history.goBack();
            }
        },
        //[addWarningToast, history, idCotizacion, idPoliza],
        []
    )

    useEffect(() => {
        getData();
    }, [getData]);

    return (
        <Loading loading={true} message="Recuperando...">
            <h1>Recuperando...</h1>
        </Loading>
    );
};
export default RecuperarCotizacionCasualityGenerales;
